import { useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import AddCategoryForm from "../components/AddCategoryForm";
import PageLayout from "../components/admin/PageLayout";

const AddCategory = () => {
  const navigate = useNavigate();

  const handleAddCategory = async (formData) => {
    try {
      const response = await apiClient.post("category/add", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.success) {
        navigate("/categories");
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  return (
    <PageLayout title="Add Category" subtitle="Create a new income or expense category with an image.">
      <AddCategoryForm onSubmit={handleAddCategory} />
    </PageLayout>
  );
};

export default AddCategory;
